(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-availability-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[data-home-catalog]')) return;
    const url = new URL(location.href);
    const inStock = url.searchParams.get('filter.v.availability') === '1';
    document.querySelectorAll('[data-availability]').forEach((link) => {
      const active = (link.dataset.availability === '1') === inStock;
      link.classList.toggle('is-selected', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      const target = new URL(url);
      target.searchParams.delete('page');
      target.searchParams.delete('filter.v.availability');
      target.searchParams.delete('catalog_availability');
      if (link.dataset.availability === '1') target.searchParams.set('filter.v.availability', '1');
      else target.searchParams.set('catalog_availability', 'all');
      link.href = target.href;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
